import { render, staticRenderFns } from "./FacebookSmmWidget.vue?vue&type=template&id=24003132&scoped=true&"
import script from "./FacebookSmmWidget.vue?vue&type=script&lang=js&"
export * from "./FacebookSmmWidget.vue?vue&type=script&lang=js&"
import style0 from "./FacebookSmmWidget.vue?vue&type=style&index=0&id=24003132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24003132",
  null
  
)

export default component.exports